import React, {FC} from 'react';

import classNames from 'classnames';
import Element from 'react-scroll/modules/components/Element';

import {useFeature} from 'components/feature';

import {STEPS} from '../../constants/checkout';

import s from './stepWrapper.scss';

type StepWrapperType = {step: STEPS; children: React.ReactNode};

/**
 * Steps Wrapper for checkout
 *
 * @constructor
 */
export const StepWrapper: FC<StepWrapperType> = ({children, step}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <section className={classNames(s.wrapper, {[s.wrapperFacelift]: isFacelift})}>
            <Element name={step}>{children}</Element>
        </section>
    );
};
